import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, isBranchUser } from "@/lib/auth";
import Layout from "@/components/dochub/Layout";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DocumentsInbox from "@/pages/DocumentsInbox";
import DocumentDetail from "@/pages/DocumentDetail";
import UploadDocument from "@/pages/UploadDocument";
import ScanCamera from "@/pages/ScanCamera";
import Vendors from "@/pages/Vendors";
import VATCodes from "@/pages/VATCodes";
import Accounts from "@/pages/Accounts";
import Integrations from "@/pages/Integrations";
import InboundSettings from "@/pages/InboundSettings";
import BusinessDefaults from "@/pages/BusinessDefaults";
import Users from "@/pages/Users";
import Branches from "@/pages/Branches";
import Items from "@/pages/Items";
import StockPrices from "@/pages/StockPrices";
import AuditLog from "@/pages/AuditLog";
import InboundLog from "@/pages/InboundLog";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-canvas text-espresso-ink/60">Loading DocHub…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (isBranchUser(user)) return <Navigate to="/scan" replace />;
  return <Navigate to="/documents" replace />;
}

function Public({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={isBranchUser(user) ? "/scan" : "/documents"} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Public><Login /></Public>} />
          <Route path="/forgot-password" element={<Public><ForgotPassword /></Public>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />

          <Route path="/" element={<HomeRedirect />} />
          <Route path="/documents" element={<Protected><DocumentsInbox /></Protected>} />
          <Route path="/documents/:id" element={<Protected><DocumentDetail /></Protected>} />
          <Route path="/upload" element={<Protected><UploadDocument /></Protected>} />
          <Route path="/scan" element={<Protected><ScanCamera /></Protected>} />
          <Route path="/vendors" element={<Protected><Vendors /></Protected>} />
          <Route path="/vat-codes" element={<Protected><VATCodes /></Protected>} />
          <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
          <Route path="/integrations" element={<Protected><Integrations /></Protected>} />
          <Route path="/inbound" element={<Protected><InboundSettings /></Protected>} />
          <Route path="/business-defaults" element={<Protected><BusinessDefaults /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="/branches" element={<Protected><Branches /></Protected>} />
          <Route path="/items" element={<Protected><Items /></Protected>} />
          <Route path="/stock-prices" element={<Protected><StockPrices /></Protected>} />
          <Route path="/audit-log" element={<Protected><AuditLog /></Protected>} />
          <Route path="/inbound-log" element={<Protected><InboundLog /></Protected>} />
          <Route path="*" element={<HomeRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
